<div class="u-flex-column">
  <div class="col">
    <section class="u-flex-column">
      <div
        *ngIf="customerSettings()?.isShippingEnabled"
        class="col-12">
        <mat-card
          appearance="outlined"
          class="stepper-card">
          <mat-card-header>
            <mat-card-title>
              {{ localizationConstants.SERVICE_REQUEST_STEP_SHIPPING_REQUEST_TITLE | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <table class="o-list-table o-list-table--compact">
              <tr class="o-list-table__item">
                <td class="o-list-table__description">
                  <mat-checkbox
                    [ngModel]="isShipmentRequested()"
                    (change)="isShipmentRequestedChange.emit($event.checked)"
                    name="isShipmentRequested"
                    labelPosition="before">
                    {{
                      localizationConstants.SERVICE_REQUEST_STEP_IS_SHIPPING_REQUESTED | translate
                    }}
                  </mat-checkbox>
                </td>
              </tr>
              <tr *ngIf="customerSettings().shippingNotes">
                <td class="o-list-table__description">
                  <div class="c-label c-info-box">
                    <mat-icon
                      class="icon-size-xxs"
                      svgIcon="information"></mat-icon>
                    <span>
                      {{ customerSettings().shippingNotes }}
                    </span>
                  </div>
                </td>
              </tr>
            </table>
          </mat-card-content>
        </mat-card>
        <mat-divider></mat-divider>
      </div>
      <div class="col-12">
        <mat-card
          appearance="outlined"
          class="stepper-card">
          <mat-card-header>
            <mat-card-title>
              {{ localizationConstants.SERVICE_REQUEST_STEP_SENDER | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="u-pt--medium u-pb--medium">
              <mat-select
                [placeholder]="
                  localizationConstants.SERVICE_REQUEST_STEP_SHIPPING_PLACEHOLDER | translate
                "
                #sender="ngModel"
                id="sender"
                name="sender"
                [ngModel]="shipFromOptionSelected()"
                (ngModelChange)="onShipFromOptionSelected($event)"
                type="text"
                class="c-select c-select--md u-minw--400 u-w--full"
                required>
                <mat-option
                  *ngFor="let shipFrom of availableShipFromList()"
                  [value]="shipFrom">
                  {{ shipFrom.displayName + " " + shipFrom.address1 }}
                </mat-option>
                <mat-option
                  *ngIf="!isShipmentRequested()"
                  [value]="otherShipFromOption">
                  {{ localizationConstants.SERVICE_REQUEST_STEP_OTHER_ADDRESS | translate }}
                </mat-option>
                <mat-option *ngIf="availableShipFromList().length === 0 && isShipmentRequested()">
                  {{ localizationConstants.SERVICE_REQUEST_STEP_NO_SHIP_FROM_ADDRESS | translate }}
                </mat-option>
              </mat-select>
              <app-form-field-error [control]="sender.control"></app-form-field-error>
            </div>
            <table class="o-list-table o-list-table--compact">
              <tr class="o-list-table__item">
                <td
                  scope="row"
                  class="o-list-table__title">
                  {{ localizationConstants.SERVICE_REQUEST_STEP_COMPANY | translate }}
                </td>
                <td>
                  {{ companyService.selectedCompany.fullName }}
                </td>
              </tr>
              <ng-container *ngIf="!isOtherShipFromOptionSelected()">
                <tr>
                  <td
                    scope="row"
                    class="o-list-table__title">
                    {{ localizationConstants.SERVICE_REQUEST_STEP_ADDRESS | translate }}
                  </td>
                  <td class="u-pt--medium">
                    {{ currentShipFrom()?.displayName }}
                  </td>
                </tr>
                <tr *ngIf="currentShipFrom()?.address1">
                  <td
                    scope="row"
                    class="o-list-table__title"></td>
                  <td class="u-pt--medium">
                    {{ currentShipFrom()?.address1 }}
                  </td>
                </tr>
                <tr *ngIf="currentShipFrom()?.address2">
                  <td
                    scope="row"
                    class="o-list-table__title"></td>
                  <td class="u-pt--medium">
                    {{ currentShipFrom()?.address2 }}
                  </td>
                </tr>
                <tr *ngIf="currentShipFrom()?.address3">
                  <td
                    scope="row"
                    class="o-list-table__title"></td>
                  <td class="u-pt--medium">
                    {{ currentShipFrom()?.address3 }}
                  </td>
                </tr>
              </ng-container>
              <div class="u-mt--medium">&nbsp;</div>
            </table>
            <textarea
              *ngIf="isOtherShipFromOptionSelected()"
              #otherAddressTextArea
              name="customAddress"
              [ngModel]="otherAddressInput()"
              (keyup)="onOtherShipFromAddressInput($event)"
              class="c-input c-input--alpha c-textarea"
              [class.is-invalid]="isOtherAddressInvalid()"
              [required]="isOtherShipFromOptionSelected()">
            </textarea>
            <div class="u-mt--small">
              <mat-error *ngIf="isOtherAddressInvalid()">
                {{ localizationConstants.LABEL_REQUIRED | translate }}
              </mat-error>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <mat-divider></mat-divider>
      <div class="col-12">
        <mat-card
          appearance="outlined"
          class="stepper-card">
          <mat-card-header>
            <mat-card-title>
              {{ localizationConstants.SERVICE_REQUEST_STEP_RECEIVER_TITLE | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <table class="o-list-table o-list-table--compact u-w--full">
              <tr class="o-list-table__item">
                <td
                  scope="row"
                  class="o-list-table__title u-w--50">
                  {{ localizationConstants.SERVICE_REQUEST_STEP_SHOP | translate }}
                </td>
                <td class="o-list-table__description u-p--0">
                  <mat-select
                    [placeholder]="
                      localizationConstants.SERVICE_REQUEST_STEP_SHOP_PLACEHOLDER | translate
                    "
                    #receiver="ngModel"
                    id="receiver"
                    name="receiver"
                    [ngModel]="vendorName()"
                    (ngModelChange)="vendorNameChange.emit($event)"
                    type="text"
                    class="c-select c-select--md"
                    required>
                    <mat-option
                      *ngFor="let option of availableVendorList()"
                      [value]="option.vendorName">
                      {{ option.vendorDescription ? option.vendorDescription : option.vendorName }}
                    </mat-option>
                    <mat-option *ngIf="availableVendorList().length === 0">
                      {{
                        localizationConstants.SERVICE_REQUEST_STEP_NO_SHIP_TO_ADDRESS | translate
                      }}
                    </mat-option>
                  </mat-select>
                  <app-form-field-error [control]="receiver.control"></app-form-field-error>
                </td>
              </tr>
            </table>
          </mat-card-content>
        </mat-card>
      </div>
    </section>
  </div>
</div>
